<template>
  <div class="case-progress">
    <div class="case-progress-left">
      <!-- <Button @click="tabActive='ADAP'">材料申请</Button>
            <Button @click="tabActive='RR'">立案</Button>
            <Button @click="tabActive='INVE'">侦查行动</Button>
            <Button @click="tabActive='EC_EC'">结案</Button> -->

      <Timeline class="time-line-body">
        <TimelineItem v-for="(item,index) in processList" :key="index">
          <Icon
            v-if="item.colorMark" slot="dot"
            type="ios-radio-button-on" :size="18"
            :color="styles.globalMainColor"
          />
          <Icon
            v-else slot="dot"
            type="md-radio-button-off" :size="18"
            :color="styles.borderColor"
          />
          <Row class="line-content">
            <Row class="line-right">
              <span :class="['line-name',!item.colorMark?'not-arrived':'']" @click="item.state==0?'':chooseNode(item.code,item.processId,item.state)">{{ item.name }}</span>

              <Button
                v-for="optional in item.optionalNode" v-if="(!optional.flag)"
                :key="optional.id"
                class="list-options"
                :disabled="item.state!==1" size="small"
                type="warning" @click="item.state==0?'':chooseOptionalNode(optional.code,item.processId,optional.id)"
              >{{ optional.name }}</Button>
            </Row>

            <Row
              v-for="log in item.logList" :key="log.id"
              class="line-detail"
            >
              <span class="line-date">{{ common.formatTime(log.operateTime,4) }}</span>
              <span :class="['line-text',log.style]">{{ log.content }}</span>
            </Row>
          </Row>
        </TimelineItem>
      </Timeline>
    </div>
    <div class="case-progress-right">
      <administrative-apply
        v-if="tabActive=='ADAP'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <set-up-case
        v-if="tabActive=='RR'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <investigative-action
        v-if="tabActive=='INVE'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <close-case
        v-if="tabActive=='EC_EC'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <!-- 3号产品 -->
      <early-stage-investigation
        v-if="tabActive == 'PI'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <filing-stage
        v-if="tabActive == 'CF'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <action-stage
        v-if="tabActive == 'AT'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <judgment-stage
        v-if="tabActive == 'PU'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
      <payment-confirmation
        v-if="tabActive == 'ST'" :process-id="processId"
        :case-id="caseId" @reloadProcess="reloadProcess"
      />
    </div>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import administrativeApply from './administrativeApply/index.vue'
import setUpCase from './setUpCase/index.vue'
import investigativeAction from './investigativeAction/index.vue'
import closeCase from './closeCase/index.vue'
// 3号产品行政案件表单
import earlyStageInvestigation from './earlyStageInvestigation/index.vue'
import filingStage from './filingStage/index.vue'
import actionStage from './actionStage/index.vue'
import judgmentStage from './judgmentStage/index.vue'
import paymentConfirmation from './paymentConfirmation/index.vue'
export default {
  components: {
    administrativeApply,
    setUpCase,
    investigativeAction,
    closeCase,
    earlyStageInvestigation,
    filingStage,
    actionStage,
    judgmentStage,
    paymentConfirmation
  },
  props: ['caseId', 'projectId'],
  data () {
    return {
      styles: styles,
      tabActive: '',
      processId: '',
      nodeId: '',
      processState: '',
      processList: []
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getCaseProcess()
  },
  updated() {},
  methods: {
    // 流程节点点击事件
    chooseNode(code, id, state) {
      this.tabActive = code
      this.processId = id
      this.processState = state
    },
    // 节点options操作
    chooseOptionalNode(code, id, nodeId) {
      this.tabActive = code
      this.processId = id
      this.nodeId = nodeId
    },
    // 获取案件进程节点
    getCaseProcess() {
      const url = '/business/case/process?caseId=' + this.caseId
      this.$get(url).then(async res => {
        if (res.code === 0) {
          this.processList = res.data
          let index = -1
          for (let i = 0; i < this.processList.length; i++) {
            if (this.processList[i].logList && this.processList[i].logList.length) {
              index = i
            }
          }
          if (index === -1) {
            index = 0
          }
          this.tabActive = this.processList[index].code
          this.processId = this.processList[index].processId
          this.processState = this.processList[index].state
        }
      })
    },
    reloadProcess() {
      this.tabActive = ''
      this.getCaseProcess()
    }
  }
}
</script>
<style scoped lang="scss">
 @import '../case/caseProgress.scss';
</style>



// WEBPACK FOOTER //
// src/view/administrativeCase/index.vue